export default __webpack_public_path__ + "static/media/no-image.2947be84.png";